import React, { useState, useEffect } from 'react';
import '../App.css';

function SpecialNoteDetailModal({ isOpen, onClose, specialNote, supervisors, onUpdateSpecialNote, onDeleteSpecialNote }) {
  const [isEditMode, setIsEditMode] = useState(false);
  const [editedNote, setEditedNote] = useState(specialNote);

  useEffect(() => {
    setEditedNote(specialNote);
    setIsEditMode(false); // 모달 열릴 때 읽기 모드로 시작
  }, [specialNote]);

  if (!isOpen || !specialNote) return null;

  const supervisorName = supervisors.find(s => s.id === specialNote.supervisorId)?.name || '알 수 없음';

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedNote(prev => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    onUpdateSpecialNote(editedNote);
    setIsEditMode(false);
  };

  const handleDelete = () => {
    onDeleteSpecialNote(specialNote.id);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="modal-close-button">×</button>
        <h2>특이사항 상세</h2>

        <div className="detail-item">
          <strong>날짜:</strong> {specialNote.scheduledDate}
        </div>
        <div className="detail-item">
          <strong>감리원:</strong> {supervisorName}
        </div>
        <div className="detail-item">
          <strong>유형:</strong>
          {isEditMode ? (
            <select name="noteType" value={editedNote.noteType} onChange={handleInputChange} className="form-control">
              <option value="휴가">휴가</option>
              <option value="병가">병가</option>
              <option value="기타">기타</option>
            </select>
          ) : (
            <span>{specialNote.noteType}</span>
          )}
        </div>
        <div className="detail-item">
          <strong>비고:</strong>
          {isEditMode ? (
            <textarea name="remarks" value={editedNote.remarks} onChange={handleInputChange} className="form-control" rows="3"></textarea>
          ) : (
            <span>{specialNote.remarks || '없음'}</span>
          )}
        </div>

        <div className="form-actions">
          {isEditMode ? (
            <button onClick={handleSave} className="submit-button">저장</button>
          ) : (
            <button onClick={() => setIsEditMode(true)} className="action-button edit-button">수정</button>
          )}
          <button onClick={handleDelete} className="action-button delete-button">삭제</button>
        </div>
      </div>
    </div>
  );
}

export default SpecialNoteDetailModal;